import { del, get, post, put } from "../util/http.service";

export const apiGetMemos = params => ({
  queryKey: ["memos", params],
  queryFn: () => get("/api/memos", params)
});

export const apiCreateMemo = () => ({
  mutationFn: data => post("/api/memos", data)
});

export const apiUpdateMemo = id => ({
  mutationFn: data => put("/api/memos/" + id, data)
});

export const apiDeleteMemo = () => ({
  mutationFn: data => del("/api/memos/" + data.id)
});

export const apiCreateMemoFile = () => ({
  mutationFn: data => post("/api/memos/" + data.memoId + "/files", data.data)
});

export const apiDeleteMemoFile = () => ({
  mutationFn: data => del("/api/memos/" + data.memoId + "/files/" + data.fileId)
});
